export default __webpack_public_path__ + "static/media/endorsement-barebow-vibes.e7b93ea6.png";